import { render } from "./escolaridadeAll.vue?vue&type=template&id=f10ad240"
import script from "./escolaridadeAll.vue?vue&type=script&lang=js"
export * from "./escolaridadeAll.vue?vue&type=script&lang=js"

import "./escolaridadeAll.vue?vue&type=style&index=0&id=f10ad240&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__